import React from 'react';
import * as api from '../../api/facility'
import PageList from '../../components/PageListAPI'
import { useCan } from 'src/hooks/useCan';
import { SLUGS } from 'src/enum/permissions.enum';

export default function FacilityMachineList(props) {
  const can = useCan()
  return (
    <div className='App-paper'>
      <PageList
        name='facilityResp'
        title='Техника на объекте'
        columns={[
          { id: 'dateCreate', name: 'Дата', type: 'date', formatDate: 'LLL', width: 220 },
          { id: 'govNumber', name: 'Гос. номер', width: 150  },
          { id: 'model', name: 'Модель' },
        ]}
        createItem={can(SLUGS.FACILITY.MACHINE.MANAGE)}
        deleteItem={can(SLUGS.FACILITY.MACHINE.MANAGE)}
        idName='id'
        loadAPI={{
          request: api.getFacilityMachine,
          param: { idFacility: props.match.params.idFacility },
        }
        }
        deleteAPI={api.delFacilityMachine(props.match.params.idFacility)}
        click={false}
        {...props}
      />
    </div>
  )
}